export default __webpack_public_path__ + "static/media/image (1).d3efc5cf.png";